(function () {
  const bar = document.querySelector('[data-lace-sticky-atc]');
  const trigger = document.querySelector('[data-lace-sticky-atc-trigger]');
  if (!bar || !trigger) return;

  const mobileQuery = window.matchMedia('(max-width: 749px)');

  const setVisible = (visible) => {
    bar.classList.toggle('is-visible', visible);
    document.body.classList.toggle('lace-sticky-atc-pad', visible);
  };

  const sync = () => {
    if (!mobileQuery.matches) {
      setVisible(false);
      return;
    }

    const rect = trigger.getBoundingClientRect();
    const outOfView = rect.bottom < 0 || rect.top > window.innerHeight;
    setVisible(outOfView);
  };

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        if (!mobileQuery.matches) {
          setVisible(false);
          return;
        }
        entries.forEach((entry) => setVisible(!entry.isIntersecting));
      },
      { threshold: 0 }
    );
    observer.observe(trigger);
  } else {
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', sync);
  } else if (typeof mobileQuery.addListener === 'function') {
    mobileQuery.addListener(sync);
  }
})();
